$(document).ready(function() {

  //changement de texte dans le button de la newsletter
  $(window).on('load resize', function() {
    var button = $('.o-newsletter').find('button');

    if ($(window).width() <= 767) {
      button.text("s'inscrire");
    } else {
      button.text('me tenir informé');
    }
  });
});